var EPK = EPK || {};
EPK.Line = EPK.Line || {};

EPK.Line.Common = function(){};

EPK.Line.Common.prototype.initialize = function(){
	var _this = this;
	var location_path = document.location.pathname;
	$('#line_all').attr('checked', false);
	$('input[name=line]').attr('checked', false);
	$('#station_all').attr('checked', false);
	$('input[name=line_sel_all]').attr('checked', false);
	$('input[name=station]').attr('checked', false);
};

EPK.Line.Common.prototype.desableAllUnchecked = function($checked){
	this.desableUnchecked($('#line_all'), $checked);
	this.desableUnchecked($('input[name=line]'), $checked);
	this.desableUnchecked($('#station_all'), $checked);
	this.desableUnchecked($('input[name=line_sel_all]'), $checked);
	this.desableUnchecked($('input[name=station]'), $checked);
};
EPK.Line.Common.prototype.desableUnchecked = function($target, $checked) {
	$target.each(function(){
		var $this = $(this);
		if($this.get(0) !== $checked.get(0)){
			$this.attr('disabled', 'disabled');
		}
	})
};

EPK.Line.Common.prototype.calcShopCount = function(elem, btnSearch, btnSelect, $checkedElement) {
	this.desableAllUnchecked($checkedElement);
	var shop_count = 0;
	var area_ids = [];
	var area_romas = [];
	var query = '';
	var select_target_url = '';
	var str = '';
	var mode = ($('#mode').attr('value')!="")?1:0;
	var change_place = ($('#change_place').val()!="")?1:0;
	var km_brand_page_id = ($('#km_brand_page_id').val()!="")?$('#km_brand_page_id').val():'';

	var arr = (location.search!="")?location.search.replace('?','').split('&'):[];
	for(i=0;i<arr.length;i++){
		var tmp = arr[i].split('=');
		if((tmp[0]!='area_id[]')&&(tmp[0]!='line_cd[]')&&(tmp[0]!='station_cd[]')&&(tmp[0]!='pref_cd')&&(tmp[0]!='mode')&&(tmp[0]!='zip_code')&&(tmp[0]!='map')){
			query = query+((query=='')?'?':'&')+arr[i];
		}
	}
	elem.each(function(){
		if($(this).prop('checked')){
			shop_count += parseInt($(this).attr('value'));
			area_ids.push($(this).attr('id'));
			area_romas.push($(this).attr('roma'));
		}
	});
	$('#shop_count').text(shop_count);
	if(shop_count > 0){
		btnSelect.removeClass('is-disable-gray').addClass('is-white');
		btnSearch.removeClass('is-disable-gray');
		if(area_ids.length == 1){
			if(mode){
				select_target_url = '/select/station'+query+((query=='')?'?':'&')+'pref_cd='+$('#pref_key').attr('value')+'&line_cd[]='+area_ids[0]+'&mode='+$('#mode').attr('value');
			} else if(change_place){
				select_target_url = '/'+$('#pref_key').attr('value')+'/line/'+area_romas[0]+query;
			} else {
				select_target_url = '/'+$('#pref_key').attr('value')+'/line/'+area_romas[0];
			}
		} else {
			for(i=0;i<area_ids.length;i++){
				if(i==0){
					str = (query=="")?'?':'&';
				} else {
					str = '&'
				}
				query = query + str+"line_cd[]="+area_ids[i];
			}
			if(mode){
				select_target_url = '/select/station'+query+((query=='')?'?':'&')+'pref_cd='+$('#pref_key').attr('value')+'&mode='+$('#mode').attr('value');
			} else if(change_place){
				select_target_url = '/'+$('#pref_key').attr('value')+'/line/station'+ query;
			} else {
				select_target_url = '/'+$('#pref_key').attr('value')+'/line/station'+ query;
			}
		}
		if((km_brand_page_id!="")&&(select_target_url.indexOf('km_brand_page_id=')==-1)){
			select_target_url = select_target_url+((select_target_url.indexOf('?')!=-1)?'&':'?')+'km_brand_page_id='+km_brand_page_id;
		}
		btnSearch.attr("href", select_target_url);
		window.location.href = select_target_url;
	} else {
		btnSearch.addClass('is-disable-gray');
		btnSearch.attr("href", "javascript:void(0);");
	}
};


EPK.Line.Common.prototype.calcShopCountStation = function(elem, btnSearch, $checkedElement) {
	this.desableAllUnchecked($checkedElement);
	var shop_count = 0;
	var station_ids = [];
	var query = '';
	var target_url = '';
	var select_target_url = '';
	var str = '';
	var mode = ($('#mode').val()!="")?1:0;
	var change_place = ($('#change_place').val()!="")?1:0;
	var km_brand_page_id = ($('#km_brand_page_id').val()!="")?$('#km_brand_page_id').val():'';
	var arr = (location.search!="")?location.search.replace('?','').split('&'):[];

	for(i=0;i<arr.length;i++){
		var tmp = arr[i].split('=');
		if((tmp[0]!='area_id[]')&&(tmp[0]!='line_cd[]')&&(tmp[0]!='station_cd[]')&&(tmp[0]!='pref_cd')&&(tmp[0]!='mode')&&(tmp[0]!='zip_code')&&(tmp[0]!='map')&&(tmp[0]!='km_brand_page_id')){
			query = query+((query=='')?'?':'&')+arr[i];
		}
	}
	elem.each(function(){
		if($(this).prop('checked')){
			shop_count += parseInt($(this).attr('value'));
			station_ids.push($(this).attr('id'));
		}
	});
	$('#shop_count').text(shop_count);
	if(shop_count > 0){
		btnSearch.removeClass('is-disable-gray');
		if(station_ids.length == 1){
			if(mode){
				target_url = '/condition'+query+((query=='')?'?':'&')+'pref_cd='+$('#pref_key').attr('value')+'&station_cd[]='+station_ids[0]+'&mode='+$('#mode').attr('value');
			} else if(change_place){
				target_url = '/'+$('#pref_key').attr('value')+'/line/station/'+station_ids[0]+query;
			} else {
				target_url = '/'+$('#pref_key').attr('value')+'/line/station/'+station_ids[0];
			}
		} else {
			for(i=0;i<station_ids.length;i++){
				if(i==0){
					str = (query=="")?'?':'&';
				} else {
					str = '&'
				}
				query = query + str+"station_cd[]="+station_ids[i];
			}
			if(mode){
				target_url = '/condition'+query+((query=='')?'?':'&')+'pref_cd='+$('#pref_key').attr('value')+'&mode='+$('#mode').attr('value');;
			} else if(change_place){
				target_url = '/'+$('#pref_key').attr('value')+'/line/station/shop'+ query;
			} else {
				target_url = '/'+$('#pref_key').attr('value')+'/line/station/shop'+ query;
			}
		}
		if (km_brand_page_id != "") {
			target_url = '/brand/'+km_brand_page_id+target_url;
		}
		if((km_brand_page_id!="")&&(target_url.indexOf('km_brand_page_id=')==-1)&&(target_url.indexOf('/brand/') < 0)){
			target_url = target_url+((target_url.indexOf('?')!=-1)?'&':'?')+'km_brand_page_id='+km_brand_page_id;
		}
		btnSearch.attr("href", target_url);
		window.location.href = target_url;
	} else {
		btnSearch.addClass('is-disable-gray');
		btnSearch.attr("href", "javascript:void(0);");
	}
};

$(function(){
	var Line = new EPK.Line.Common();
	Line.initialize();

	// 路線選択画面でのすべて選択のクリック
	$('#line_all').on('change', function() {
		var $this = $(this);
		$('input[name=line]').prop('checked', this.checked);
		Line.calcShopCount($('input[name=line]'),$('#btnSearch'),$('#btnSelect'), $this);
	});
	// 路線選択画面でのすべて選択のクリック
	$('input[name=line]').on('change', function() {
		var $this = $(this);
		var $stationCheck = $('input[name=station]');
		$('input[name=line]').prop('disable', "disable");
		if($stationCheck.length >0){
			var checked = this.checked;
			$stationCheck.each(function(){
				if($this.attr('parent_id') == $this.attr('id')) {
					$this.prop('checked', checked);
				}
			});
			Line.calcShopCountStation($('input[name=station]'),$('#btnSearch'), $this);
		} else {
			Line.calcShopCount($('input[name=line]'),$('#btnSearch'),$('#btnSelect'), $this);
		}
	});
	// 駅選択画面でのすべて選択のクリック
	$('#station_all').on('change', function() {
		var $this = $(this);
		$('input[name=line]').prop('checked', this.checked);
		$('input[name=line_sel_all]').prop('checked', this.checked);
		$('input[name=station]').prop('checked', this.checked);
		Line.calcShopCountStation($('input[name=station]'),$('#btnSearch'), $this);
	});
	// 市区選択画面でのすべて選択のクリック
	$('input[name=line_sel_all]').on('change', function() {
		var $this = $(this);
		$('input[name=line]').prop('checked', this.checked);
		$('input[name=line]').each(function(){
			var checked = this.checked;
			$('input[name=station]').each(function(){
				if($(this).attr('parent_id') == $this.attr('id')) {
					$(this).prop('checked', checked);
				}
			});
		});
		Line.calcShopCountStation($('input[name=station]'),$('#btnSearch'), $this);
	});
	// 市区選択画面でのすべて選択のクリック
	$('input[name=station]').on('change', function() {
		var $this = $(this);
		Line.calcShopCountStation($('input[name=station]'),$('#btnSearch'), $this);
	});
});
